import { Component, OnInit, ViewChild } from '@angular/core';
import { Setor } from '../models/setor';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MatDialog, MatPaginator, PageEvent } from '@angular/material';
import swal from 'sweetalert2';
import { CadastrarSetorModalComponent } from '../modals/cadastrar-setor-modal/cadastrar-setor-modal.component';
import { CarregandoService } from '../services/carregando.service';
import { NotificacaoService } from '../services/notificacao.service';
import { SetorService } from '../services/setor.service';
import { UtilitarioService } from '../services/utilitario.service';
import { PaginatorService } from '../services/paginator.service';

// jquery
declare const $: any;

@Component({
  selector: 'app-setor',
  templateUrl: './setor.component.html',
  styleUrls: ['./setor.component.scss']
})
export class SetorComponent implements OnInit {
  descricao: string;
  setores: Setor[] = [];
  carregando = true;
  campoOrdenacao = 'descricao';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  public config: PerfectScrollbarConfigInterface = {};

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(
    private carregandoService: CarregandoService,
    public utilitarioService: UtilitarioService,
    private notificacaoService: NotificacaoService,
    private setorService: SetorService,
    public dialog: MatDialog,
    private paginatorService: PaginatorService
  ) {}

  ngOnInit(): void {
    const pagination = this.paginatorService.consultarPaginacao();
    
    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;
    
    this.buscarSetores();
  }

  buscarSetores() {
    this.carregandoService.mostra('buscarSetores');

    this.setorService.consultarComPaginacao(this.descricao, this.paginacao.paginaAtual, this.itensPorPagina, this.campoOrdenacao, (this.ordenarDesc ? 'desc' : 'asc')).subscribe((data: any) => {
      this.setores = data.itens;

      if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
        this.itensPorPagina = 10;
      }

      this.paginacao.total = data.total;

      this.carregando = false;
      this.carregandoService.esconde('buscarSetores');
    }, (erro) => {
      this.carregandoService.esconde('buscarSetores');
      this.notificacaoService.erro(erro);
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarSetores();
  }

  excluirItem(idSetor) {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir o setor?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('excluirItem');
        this.setorService.excluir(idSetor).subscribe(resp => {
          this.notificacaoService.sucesso('Setor excluído com sucesso!!!');
          this.carregandoService.esconde('excluirItem');
          this.buscarSetores();

        }, (erro) => {
          this.carregandoService.esconde('excluirItem');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  novoItem() {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarSetorModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: { },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: Setor) => {
      if (result) {
        this.buscarSetores();
      }
    });
  }

  editarItem(idSetor: number) {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(CadastrarSetorModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: { idSetor },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: Setor) => {
      if (result) {
        this.buscarSetores();
      }
    });
  }
}